import { AnvaQuote } from '@flows/src/types/anva';
import { create } from 'zustand';

interface FlowsProductSelectionStore {
  selectedItems: AnvaQuote[];
  addToSelected: (item: AnvaQuote) => void;
  removeFromSelected: (item: AnvaQuote) => void;
  replaceSelected: (item: AnvaQuote) => void;
  reset: () => void;
}

const useAnvaFlowProductSelectionStore = create<FlowsProductSelectionStore>(
  (set) => ({
    selectedItems: [],
    addToSelected: (item) =>
      set((state) => ({
        selectedItems: [...state.selectedItems, item],
      })),
    removeFromSelected: (itemToRemove) =>
      set((state) => ({
        selectedItems: state.selectedItems.filter(
          (item) =>
            !(item.id === itemToRemove.id && item.index === itemToRemove.index),
        ),
      })),
    replaceSelected: (item) =>
      set((state) => ({
        selectedItems: state.selectedItems.map((oldItem) =>
          item.anva_product_id === oldItem.anva_product_id &&
          item.index === oldItem.index
            ? item
            : oldItem,
        ),
      })),
    reset: () =>
      set(() => ({
        selectedItems: [],
      })),
  }),
);

export default useAnvaFlowProductSelectionStore;
